<template>
	<!--Header matching compass public website https://www.compassnzl.co.nz/ -->
	<div class="top-bar">
		<div class="inner-width">
			<div class="topbar-description pl-3 xl:pl-0"><!--BWOF-Building Inspection &ndash; Code of Compliance &ndash; Fire Evacuation Safety Procedures Plan--></div>
			<a href="https://www.compassnzl.co.nz/" class="button-section"><Button label="Compass Website" /></a>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.top-bar {
		overflow: scroll;
		background-color: #efefef;
		overflow: hidden;
		box-sizing: inherit;
		color: #404040;
		border-bottom: 1px solid #eaeaea;
		font-family: Graphik,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif;

		.topbar-description {
			padding: .5rem 0;
			color: #666;
			font-style: italic;
			text-transform: lowercase;
			font-size: 1.2rem;
		}

		.button-section {
			// Copied the way it works from the wordpress website
			@media screen and (max-width: 887px) {
				display: none;
			}
		}
	}

	.inner-width {
		max-width: 1200px;
		margin: auto;
		display: flex;
		justify-content: space-between;
	}

	// Compass Website button at the top
	.p-button:enabled {
		color: white;
		background-color: #990000 !important;
		font-size: 1.2rem;
		border-radius: 0px;
	}

	.p-button:enabled:hover {
		background-color: #333 !important;
	}
</style>